import React, { Component } from "react";

class Register extends Component {
    render() {
        return (
          <div>
            <h2>S’enregistrer</h2>
            <form method="post">
              <p>
                <label htmlFor="reg_email">Adresse de messagerie&nbsp;<span
                >*</span></label>
                <input type="email"
                       name="email" id="reg_email" autoComplete="email" value=""/></p>
              <p>Un mot de passe sera envoyé vers votre adresse de messagerie.</p>
              <div>
                <div>
                  <p>
                    <label htmlFor="first-name">First Name <span>*</span></label>
                    <input type="text"
                           value="" required="required"/>
                  </p>
                  <p>
                    <label htmlFor="last-name">Last Name <span>*</span></label>
                    <input type="text"
                           value="" required="required"/>
                  </p>
                </div>
                <p>
                  <label htmlFor="company-name">Shop Name <span>*</span></label>
                  <input type="text"
                         value="" required="required"/>
                </p>
                <p>
                  <label htmlFor="seller-url">Shop URL <span
                  >*</span></label>
                  <strong id="url-alart-mgs"></strong>
                  <input type="text"
                         value="" required="required"/>
                  <small>https://app.bienvenus.com/store/<strong id="url-alart"></strong></small>
                </p>
                <p>
                  <label htmlFor="shop-phone">Phone Number<span>*</span></label>
                  <input type="text"
                         value="" required="required"/>
                </p>
              </div>
              <p>
                <label>
                  <input type="radio" name="role" value="customer" checked="checked"/>
                  I am a customer </label>
                <label>
                  <input type="radio" name="role" value="seller"/>
                  I am a vendor </label>
              </p>
              <p>
                <input type="hidden" id="woocommerce-register-nonce" name="woocommerce-register-nonce"
                       value="866464429d"/><input type="hidden" name="_wp_http_referer" value="/"/>
                <button type="submit"
                        name="register" value="S’enregistrer">S’enregistrer
                </button>
              </p>
            </form>
          </div>
        );
    }
}

export default Register;